<script>
import domtoimage from '../../plugins/dom-to-image';
import setBlobImageSize from '../../plugins/setBlobImageSize';
import { mapGetters } from 'vuex'

function blobToDataURL(blob) {
    var a = new FileReader();
    return new Promise((reslove, reject) => {
      a.onload = function(e) {
        reslove(e.target.result);
      }
      a.readAsDataURL(blob);
    })
}

export default {
  data () {
    return {

    }
  },
  components: {

  },
  computed: {
    ...mapGetters([
      'TOOL',
    ]),
  },
  methods: {
    getSnapsInScenes () {

    },
    getSnapByDom (dom) {
      let myResolve
      dom.style.display = '';
      domtoimage.toBlob2(dom, {
        useFont: false,
        bgcolor: '#ffffff',
        _width: dom.offsetWidth,
        _height: dom.offsetHeight,
        width: 640,
        height: 640 * dom.offsetHeight / dom.offsetWidth,
        quality: 0.5,
        style: {
          overflow: 'hidden',
        }
      })
        .then(blob => {
          if (this.TOOL.optimized !== 'Horizontal') {
            let height = 640 * dom.offsetHeight / dom.offsetWidth;
            let width = height * 9 / 16;
            setBlobImageSize({
              blob,
              height,
              width,
              sx: (640 - width) / 2,
              sy: 0,
              sw: width,
              sh: height
            })
              .then((blob) => {
                this.snaps.push({
                  blob,
                });

                dom.style.display = 'none';
                myResolve();
              })

            return;
          }

          this.snaps.push({
            blob,
            // url: this.getBlobUrl(blob)
          })
          dom.style.display = 'none';
          myResolve();
        })
        .catch(err => {
          console.warn(err);
          dom.style.display = 'none';
        })

      return new Promise((resolve) => {
        myResolve = resolve;
      })
    },
    getMiddlePoint () {
      let halfTime = this.TOOL.getDuration() / 2;
      let accTime = 0;
      let currIndex;
      this.TOOL.sprites.some((scene, i) => {
        accTime += scene.duration;
        currIndex = i
        return accTime >= halfTime
      });
      return {
        index: currIndex,
        diffTime: halfTime - (accTime - this.TOOL.sprites[currIndex].duration)
      };
    },
    beforeGetSnap ({ palyerScene, sec = 1, scene, isPlayerLayer = true } = {}) {
      var _y, _n, _p;
      _p = new Promise((y, n) => {
        _y = y
      });
      const vm = this;
      let $video = $(palyerScene).find('video');
      if (!$video[0]) {
        _y(false);
        return _p;
      }
      let video = $video[0];
      video.crossOrigin = true;

      let oldTime = video.currentTime;

      let canvas = document.createElement("canvas");
      canvas.width = video.offsetWidth;
      canvas.height = video.offsetHeight;
      let ctx = canvas.getContext('2d');

      video.addEventListener('timeupdate', function h() {
        var img = document.createElement("img");
        img.crossOrigin = true;

        ctx.drawImage(video,
          0, 0, canvas.width, canvas.height
          // 0, 0, video.offsetWidth, video.offsetHeight
        );
        let dataUrl = canvas.toDataURL('image/png')

        img.src= dataUrl;

        // test
        // $('body').prepend(img);

        let stylesByRatio = vm.getStylesByRatio({
          video: $video[0],
          editor: vm.TOOL
        });

        // bg video or video sprite
        let imgWrapper
        let isVideoSprite = scene.background.data.type !== 'Video';
        if (isVideoSprite) {
          let targetArr = scene.sprites.filter(s => s.type === 'Video') || []
          let target = targetArr[0];
          if (target) {
            imgWrapper = isPlayerLayer ? $('#player-sprite-' + target.id) : $('#sprite-' + target.id);
          }
        } else {
          imgWrapper = $video.closest('.mask-blur')
        }

        if (isVideoSprite) {
          imgWrapper && imgWrapper.css({
            backgroundImage: `url(${dataUrl})`,
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%'
          })
        } else {
          imgWrapper && imgWrapper.css({
            backgroundImage: `url(${dataUrl})`,
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            ...stylesByRatio,
            // backgroundColor: '#000000',
          });
        }

        _y(true);

        video.currentTime = oldTime;
        video.removeEventListener('timeupdate', h);
      })

      video.currentTime = video.currentTime;
      // console.log({sec, oldTime, curr: video.currentTime})

      // function draw(v,c,w,h) {
      //   if(v.paused || v.ended) return false;
      //   c.drawImage(v,0,0,w,h);
      //   setTimeout(draw,20,v,c,w,h);
      // }

      return _p;
    },
    getStylesByRatio ({
      ratioDefault = 16 / 9,
      video,
      editor
    } = {}) {
      let sizeX = editor.clientWidth || 0;
      let sizeY = editor.clientHeight || 0;
      let ratio = video.videoWidth / video.videoHeight || ratioDefault;
      let backgroundSize;
      let backgroundColor = 'transparent';
      if (ratio !== ratioDefault) {
        backgroundColor = '#000000';
      }

      if (ratio < ratioDefault) {
        sizeX = sizeY * ratio;
      }

      if (ratio > ratioDefault) {
        sizeY = sizeX / ratio;
      }

      backgroundSize = `${sizeX}px ${sizeY}px`;
      return {
        backgroundSize,
        backgroundColor
      }
    },

    addBlobs (el) {
      const URL_REGEX = /url\(['"]?([^'"]+?)['"]?\)/g;
      let newEl = el; // el.cloneNode(true);
      let tasks = [];
      $(newEl).find('*').each((i, el) => {
        let $myEl = $(el);
        if (el.tagName === 'IMG') {
          el.crossOrigin = 'anonymous';
        }
        let url = $(el).css('backgroundImage');
        let matches = URL_REGEX.exec(url);
        if (matches && matches[1]) {
          url = matches[1];
        } else {
          url = '';
        }
        if (url.indexOf('resources') < 0) {
          return;
        }
        console.log({url})

        let myHeaders = new Headers({
            'Access-Control-Allow-Origin': '*',
            // 'Content-Type': 'text/plain'
        });
        tasks[tasks.length] = fetch(url, {
          method: 'GET',
          headers: myHeaders,
          mode: 'cors'
        }).then(function(response) {
          return response.blob();
        }).then(async function(myBlob) {
          // let objectURL = URL.createObjectURL(myBlob);

          let dataUrl = await blobToDataURL(myBlob);
          console.log({dataUrl})
          $(el).css('backgroundImage', `url(${dataUrl})`);
          console.log({url: $(el).css('backgroundImage')})
        });
      });

      return new Promise((resolve, reject) => {
        Promise.all(tasks)
          .then(() => {
            resolve({ newEl })
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/snap.vue